export default __webpack_public_path__ + "launch-package-icon.fcc85996665bbe4e0ade280bdb8eeac2.png";